import configs from 'build/configs/configs'

const CONFIGS = configs

export default CONFIGS;